import React, {Component, PropTypes} from "react";
import getSize from "../../../utils/getSize";
import NHTable from '../../common/NHTable';
import css from './index.css';
import {Icon} from 'antd';


/**
 * Zzbdbxq 自助报到详情
 * @author sujunming
 * @date 2018-06-29 09:06:14
 * Version: 1.0
 */
export default class ZzbdxqTab extends Component {
    constructor(props) {
        super(props)
        this.state = {
            initParams: {},
            selectKey: '',
            columns: [],
        }
    }

    componentWillMount() {
        const columnConst = [
            {
                title: '序号',
                dataIndex: 'ROW_ID',
                width: '50px',
            }, {
                title: '学号',
                dataIndex: 'XH',
                width: '120px',
                searchType:"input"
            }, {
                title: '姓名',
                dataIndex: 'XM',
                width: '90px',
                search: 'input',
                searchType:"input"
            }, {
                title: '性别',
                width: '70px',
                dataIndex: 'XB',
                searchType:"select"
            }, {
                title: '身份证号',
                dataIndex: 'SFZJH',
                width: '160px',
                searchType:"input"
            }, {
                title: '院系',
                width: '200px',
                dataIndex: 'BMMC',
                searchType:"select"
            }, {
                title: '专业',
                width: '200px',
                dataIndex: 'ZYMC',
                searchType:"select",
                parentField:"BMMC"
            }, {
                title: '班级',
                width: '200px',
                dataIndex: 'BJMC',
                searchType:"select",
                parentField:"ZYMC"
            }, {
                title: '环节名称',
                width: '150px',
                dataIndex: 'HJMC',
                searchType:"select"
            }, {
                title: '办理状态',
                width: '100px',
                dataIndex: 'BLZT',
                searchType:"select"
                // render: (text) => {
                //     return text == 1 ? <Icon type="check-circle" style={{fontSize: 16, color: '#53c41a'}}/>
                //         : <Icon type="close-circle" style={{fontSize: 16, color: '#ff4d4f'}}/>;
                // }
            }, {
                title: '办理时间',
                width: '145px',
                dataIndex: 'BLSJZS',
                commonSearch:false,
                searchType:"date"
            }
        ];
        this.setState({columns: columnConst});
    }


    render() {
        return (
            <div className={css.main_right_content} style={{height: getSize().windowH - 230}}>
                <div style={{width: '100%', height: '100%',}}>
                    <NHTable ref='nhTable'
                             rowKey={record => record.PKID}
                             sign={"zhxg_yxxt_tjcx_zzbdxq_queryPage"}
                             columns={this.state.columns}
                    >
                    </NHTable>

                </div>
            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./components/tjcx/zzbdblcx/zzbdxqTab.js